import React, { useState } from "react";
import Project from "./Project";
import { arrows, topProjects } from "../../../utils";


const Slider = () => {
  const [selected, setSelected] = useState(0);

  const handleClick = (index) => {
    setSelected(index);
  };
  const handleNext = (index) => {
    setSelected((prevIndex) => (prevIndex + 1) % topProjects.length);
  };
  const handlePrev = (index) => {
    setSelected(
      (prevIndex) => (prevIndex - 1 + topProjects.length) % topProjects.length
    );
  };
  return (
    <div className="desktop_slider_section">
      <div className="desktop_slider_container">
        <div className="arrow left" onClick={() => handlePrev(selected)}>
          <div
            className="img"
            style={{ backgroundImage: `url(${arrows})` }}
          ></div>
        </div>
        <div className="desktop_slider">
          {topProjects.map((project, index) => (
            <Project
              key={index}
              project={project}
              selected={index === selected}
            />
          ))}
        </div>
        <div className="arrow right" onClick={() => handleNext(selected)}>
          <div
            className="img"
            style={{ backgroundImage: `url(${arrows})` }}
          ></div>
        </div>
      </div>
      <div className="carousel_thumbs">
        {topProjects.map((project, index) => (
          <div
            onClick={() => handleClick(index)}
            className={`carousel_thumb ${index === selected ? "active" : ""}`}
            key={index}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Slider;
